var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, CustomElement } from '@pacem/pacem-core';
import { Components } from '@pacem/pacem-scaffolding';
let PacemBodyValidatorElement = class PacemBodyValidatorElement extends Components.Scaffolding.PacemBaseValidatorElement {
    evaluate(val) {
        const valid = Utils.isNullOrEmpty(val) || (typeof val === 'string' && val.toLowerCase().indexOf('valid') >= 0);
        return Utils.fromResult(valid);
    }
};
PacemBodyValidatorElement = __decorate([
    CustomElement({
        tagName: 'pacemjs-body-validator', shadow: false,
        template: Components.Scaffolding.BASIC_VALIDATOR_TEMPLATE
    })
], PacemBodyValidatorElement);
export { PacemBodyValidatorElement };
